module.exports = __webpack_public_path__ + "img/bb_g3_nose-03.b2181c97.svg";